import { Component } from '@angular/core';
import { VariableService } from '../services/sharedVariables';

@Component({
  selector:'body-web',
  templateUrl:'../views/page-sections/body.html'
})
export class BodyWebComponent{
  public  title:string;
  public logged:boolean;

  constructor(
    private sharedVariables: VariableService
  )
  {
    this.title = "body component";
  }

  ngOnInit()
  {
    console.log("body initialized");
    this.validSession();
  }

  validSession()
  {
    if(this.sharedVariables.validSession()){
      this.logged = true;
    }
    else
      this.logged = false;
  }

}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/body.component.ts